import Request from './request';
// import consts from "@/consts.js";
import i18n from '@/i18n';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';
import store from '@/store.js';


async function fetch(data) {
    return Request('get', "api/StockMaterialHistories/index", data);
}

async function fetchOne(data) {
  return Request('get', "api/StockMaterialHistories/view", data);
}

async function exports(data) {// 导出报表
  store.dispatch("fullscreenLoading");
  const response = await Request('get', "api/StockMaterialHistories/export",data);
  if (response.data && response.data.status.isOK()) {
      snackbar.info(i18n.t("Export.recordedHint"));
  }
  store.dispatch("fullscreenLoadingStop");
  return response;
}

// 历史库存批量导出
async function batchDetailExport(data) {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/stock-material-histories/batch-detail-export', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}


export default {
  fetch,
  fetchOne,
  exports,
  batchDetailExport,
};